"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeContentSourceDataDTO = exports.decodeContentSourceDataDTO = void 0;
const t = __importStar(require("io-ts"));
const io_ts_types_1 = require("io-ts-types");
const codecs_1 = require("../codecs");
const ContentSourceData = t.exact(t.intersection([
    t.type({
        timestamp: io_ts_types_1.DateFromISOString,
        source_url: t.string,
        orgnr: (0, io_ts_types_1.optionFromNullable)(t.string),
        post_title: (0, io_ts_types_1.optionFromNullable)(t.string),
        content: t.string,
        correlation_id: io_ts_types_1.UUID,
        market: codecs_1.ISO3166Codec,
    }),
    t.partial({
        source_name: (0, io_ts_types_1.optionFromNullable)(t.string),
    }),
]));
const decodeContentSourceDataDTO = (input) => ContentSourceData.decode(input);
exports.decodeContentSourceDataDTO = decodeContentSourceDataDTO;
const encodeContentSourceDataDTO = (input) => ContentSourceData.encode(input);
exports.encodeContentSourceDataDTO = encodeContentSourceDataDTO;
//# sourceMappingURL=content-source-data.js.map